import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { stateName } from './constants';
export const initialState = {
  selectedIds: [],
  pushUpOrder: {
    fetchUiState: UiState.Idle,
    prepareUiState: UiState.Idle
  },
  pushUpCheckout: {
    activeModal: ExtraServiceCheckoutModal.None
  },
  pushUpOptions: {
    freePushUpsCount: 0,
    freePushUpsExpireInDays: 0,
    hasPaymentsAccount: false,
    options: []
  },
  pushUpMinimumPrice: {
    payable: {
      amount: '0',
      currencyCode: 'EUR'
    },
    discount: {
      amount: '0',
      currencyCode: 'EUR'
    },
    total: {
      amount: '0',
      currencyCode: 'EUR'
    },
    hasFreeBump: false
  }
};

const setSelectedItems = (draft, action) => {
  const {
    itemIds
  } = action.payload;
  draft.selectedIds = itemIds;
};

const getPushUpOrderRequest = draft => {
  draft.pushUpOrder = {
    order: undefined,
    fetchUiState: UiState.Pending,
    prepareUiState: UiState.Idle
  };
};

const getPushUpOrderFailure = draft => {
  draft.pushUpOrder = {
    order: undefined,
    fetchUiState: UiState.Failure,
    prepareUiState: UiState.Idle
  };
};

const getPushUpOrderSuccess = (draft, action) => {
  const {
    pushUpOrder
  } = action.payload;
  const itemIds = pushUpOrder.pushUpOrderItems.map(_ref => {
    let {
      itemId
    } = _ref;
    return itemId;
  });
  draft.pushUpOrder = {
    order: pushUpOrder,
    fetchUiState: UiState.Success,
    prepareUiState: UiState.Idle
  };
  draft.selectedIds = itemIds;
};

const setSelectedPushUpOption = (draft, action) => {
  const {
    selectedPushUpOption
  } = action.payload;
  draft.selectedPushUpOption = selectedPushUpOption;
  draft.pushUpOrder.fetchUiState = UiState.Idle;
};

const preparePushUpOrderRequest = draft => {
  draft.pushUpOrder = {
    order: undefined,
    prepareUiState: UiState.Pending,
    fetchUiState: UiState.Idle
  };
};

const preparePushUpOrderFailure = draft => {
  draft.pushUpOrder = {
    order: undefined,
    prepareUiState: UiState.Failure,
    fetchUiState: UiState.Idle
  };
};

const getPushUpOptionsFailure = draft => {
  draft.pushUpOrder = {
    order: undefined,
    prepareUiState: UiState.Failure,
    fetchUiState: UiState.Idle
  };
};

const preparePushUpOrderSuccess = (draft, action) => {
  const {
    pushUpOrder
  } = action.payload;
  draft.pushUpOrder = {
    order: pushUpOrder,
    prepareUiState: UiState.Success,
    fetchUiState: UiState.Idle
  };
};

const getPushUpOptionsSuccess = (draft, action) => {
  const {
    pushUpOptions
  } = action.payload;
  draft.pushUpOptions = pushUpOptions;
};

const getPushUpMinimumPriceSuccess = (draft, action) => {
  const {
    pushUpMinimumPrice
  } = action.payload;
  draft.pushUpMinimumPrice = pushUpMinimumPrice;
};

const setCheckoutModal = (draft, action) => {
  const {
    modal
  } = action.payload;
  draft.pushUpCheckout.activeModal = modal;
};

const cancelCheckout = draft => {
  draft.selectedPushUpOption = undefined;
  draft.pushUpOrder = {
    fetchUiState: UiState.Idle,
    prepareUiState: UiState.Idle
  };
};

const pushUpSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    cancelCheckout,
    setCheckoutModal,
    setSelectedItems,
    getPushUpOrderRequest,
    getPushUpOrderFailure,
    getPushUpOrderSuccess,
    setSelectedPushUpOption,
    preparePushUpOrderRequest,
    preparePushUpOrderFailure,
    preparePushUpOrderSuccess,
    getPushUpOptionsSuccess,
    getPushUpMinimumPriceSuccess,
    getPushUpOptionsFailure
  }
});
export const {
  actions
} = pushUpSlice;
export const plug = {
  [stateName]: pushUpSlice.reducer
};
export default pushUpSlice.reducer;